import React from "react";
import { NAVBAR_THEMES, NavbarTheme } from "../../constants/themes";
import { NavSectionConfig } from "../../types/navbar";
import CrossAppLink from "../CrossAppLink/CrossAppLink";

type Props = {
  mode: NavbarTheme;
  onClose: () => void;
  navConfig: NavSectionConfig[];
};

const BurgerMenuDesktop = ({ mode, onClose, navConfig }: Props) => {
  const theme = NAVBAR_THEMES[mode];
  const sections = navConfig.filter((s) => s.mobileExpand);

  return (
    <div
      onMouseLeave={onClose}
      className={`absolute right-0 top-[58px] w-[250px] rounded-2xl p-6 z-[60] shadow-[rgba(0,0,0,0.12)_0px_8px_30px_0px,rgba(0,0,0,0.06)_0px_2px_6px_0px] ${theme.dropdownBg}`}
    >
      {sections.map((section, sectionIndex) => (
        <React.Fragment key={section.title}>
          {sectionIndex > 0 && <hr className={`my-4 border-t ${theme.dropdownDivider}`} />}
          <div>
            <h3 className={`font-semibold text-base mb-3 ${theme.dropdownHeading}`}>{section.title}</h3>
            <ul className="flex flex-col gap-3">
              {section.links.map((item, i) => (
                <li key={i}>
                  <CrossAppLink to={item.link ?? "#"} onClick={onClose} className={`text-sm hover:text-primary transition-colors ${theme.dropdownSubText}`}>
                    {item.name}
                  </CrossAppLink>
                </li>
              ))}
            </ul>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default BurgerMenuDesktop;
